var searchJSON = {
  "BYD": [
    {
      "Shark": {
        "(2024 on)": "/collections/4wd-suspension-accessories-for-byd-shark-2024-on"
      }
    }
  ],
  "Chevrolet": [
    {
      "Silverado": {
        "2500 (2020 on) ": "/collections/4wd-suspension-accessories-for-chevrolet-silverado-2500-2020-on",
        "2500HD/3500HD (2010-2021)": "/collections/4wd-suspension-accessories-for-chevrolet-silverado-2500hd-3500hd-2010-2021",
        "1500 (2007-2019)": "/collections/4wd-suspension-accessories-for-chevrolet-silverado-1500-2007-2019",
        "1500HD/2500 (2001-2006)": "/collections/4wd-suspension-accessories-for-chevrolet-silverado-1500-2500-2001-2006"
      }
    }
  ],
  "Daihatsu": [
    {
      "Feroza ": {
        "F310 Wide Track (1993-1998)": "/collections/4wd-suspension-accessories-for-feroza-f310-wide-track",
        "F300 (1988-1998)": "/collections/4wd-suspension-accessories-for-daihatsu-feroza-f300"
      }
    },
    {
      "Rocky": {
        "F85 (1993-1998)": "/collections/4wd-suspension-accessories-for-daihatsu-rocky-f85",
        "F77P, F77R [Tray Back] (1984-1993)": "/collections/4wd-suspension-accessories-for-daihatsu-rocky-f77p-f77r-tray-back",
        "F25P, F55P, F65 [Tray Back] (1984-1998)": "/collections/4wd-suspension-accessories-for-daihatsu-rocky-f25p-f55p-f65-tray-back",
        "F70, F75, F80RV [Hard Top] (1984-2002)": "/collections/4wd-suspension-accessories-for-daihatsu-rocky-f70-f75-f80rv-hard-top"
      }
    }
  ],
  "Ford": [
    {
      "Ranger": {
        "RA/Next Gen (2022 on)": "/collections/4wd-suspension-accessories-for-ford-ranger-next-gen-2022-on",
        "PX3 (2019-2022)": "/collections/4wd-suspension-accessories-for-ford-ranger-px3",
        "PX1/2 (2012-2018)": "/collections/4wd-suspension-accessories-for-ford-ranger-px1-px2",
        "PJ/PK (4WD)": "/collections/4wd-suspension-accessories-for-ford-ranger-pj-pk-4wd",
        "PJ/PK (2WD High Rider)": "/collections/4wd-suspension-accessories-for-ford-ranger-pj-pk-2wd-high-rider"
      }
    },
    {
      "Ranger Raptor": {
        "Raptor (2022 on)": "/collections/4wd-suspension-accessories-for-Ford-ranger-raptor-2022-on",
        "Raptor (2018-2021)": "/collections/4wd-suspension-accessories-for-Ford-ranger-raptor-2018-2021"
      }
    },
    {
      "Everest": {
        "UB (2022+)": "/collections/4wd-suspension-accessories-for-ford-everest-2022",
        "UA (2018-2021)": "/collections/4wd-suspension-accessories-for-ford-everest-2018-2021",
        "UA (2016-2018)": "/collections/4wd-suspension-accessories-for-ford-everest-2016-2018"
      }
    },
    {
      "Courier": {
        "4WD (1999-2006)": "/collections/4wd-suspension-accessories-for-ford-courier-4wd-1999-2006",
        "2WD (1999-2005)": "/collections/4wd-suspension-accessories-for-ford-courier-2wd-1999-2005",
        "4WD (1987-1999)": "/collections/4wd-suspension-accessories-for-ford-courier-4wd-1987-199",
        "2WD (1987-1999)": "/collections/4wd-suspension-accessories-for-ford-courier-2wd-1987-1999"
      }
    },
    {
      "F250": {
        "Petrol (2000 on)": "/collections/4wd-suspension-accessories-for-ford-f-250-petrol-2000-on",
        "Diesel (2000 on)": "/collections/4wd-suspension-accessories-for-ford-f-250-diesel-2000-on"
      }
    },
    {
      "Maverick": {
        "Y60 Cab Chassis LWB - Leaf FR/RR (03/1988-09/1993)": "/collections/4wd-suspension-accessories-for-ford-maverick-y60-cab-chassis-lwb-leaf-fr-rr-03-1988-09-1993",
        "Y60 Cab Chassis LWB - Coil Spring (09/1991-09/1993)": "/collections/4wd-suspension-accessories-for-ford-maverick-y60-cab-chassis-lwb-coil-spring-09-1991-09-1993",
        "Y60 Wagon LWB - Coil Spring (03/1988-09/1993)": "/collections/4wd-suspension-accessories-for-ford-maverick-y60-wagon-lwb-coil-spring-03-1998-09-1993",
        "Y60 Wagon SWB Manual Trans (03/1988-09/1993)": "/collections/4wd-suspension-accessories-for-ford-maverick-y60-wagon-swb-manual-trans-03-1988-09-1993"
      }
    },
    {
      "Raider": {
        "(1987-1999)": "/collections/4wd-suspension-accessories-for-ford-raider-1987-1999",
        "(1999-2005)": "/collections/4wd-suspension-accessories-for-ford-raider-1999-2005"
      }
    }
  ],
  "Foton": [
    {
      "Tunland": {
        "(2012 on)": "/collections/4wd-suspension-accessories-for-foton-tunland-2012"
      }
    }
  ],
  "GWM": [
    {
      "V200 & V240": {
        "(2011-2016)": "/collections/4wd-suspension-accessories-for-great-wall-motor-gwm-v200-v240"
      }
    },
    {
      "X200 & X240": {
        "(2009-2014)": "/collections/4wd-suspension-accessories-for-great-wall-motor-gwm-x200-x240"
      }
    },
    {
      "Tank 300": {
        "(2021 on)": "/collections/4wd-suspension-accessories-for-great-wall-motor-tank-300"
      }
    },
    {
      "Tank 500": {
        "(2024 on)": "/collections/4wd-suspension-accessories-for-great-wall-motor-tank-500"
      }
    },
    {
      "Cannon": {
        "(2019 on)": "/collections/4wd-suspension-accessories-for-great-wall-motor-gwm-cannon"
      }
    }
  ],
  "Holden": [
    {
      "Colorado": {
        "RG (2012-2020)": "/collections/4wd-suspension-accessories-for-holden-colorado-rg",
        "RC (2008-2012)": "/collections/4wd-suspension-accessories-for-holden-colorado-rc",
        "Trailblazer/Colorado 7 (2012-2020)": "/collections/4wd-suspension-accessories-for-holden-colorado-trailblazer-colorado-7"
      }
    },
    {
      "Rodeo": {
        "RA (2003-2008)": "/collections/4wd-suspension-accessories-for-holden-rodeo-ra",
        "KB2/KD2/KB4/KD4 (1981-1988)": "/collections/4wd-suspension-accessories-for-holden-rodeo-kb2-kd2-kb4-kd4",
        "TF/R7/R9 (1997-2003)": "/collections/4wd-suspension-accessories-for-holden-rodeo-tf-r7-r9",
        "TFS 4WD (1988-2003)": "/collections/4wd-suspension-accessories-for-holden-rodeo-tfs-4wd",
        "TFR 2WD (1988-2003)": "/collections/4wd-suspension-accessories-for-holden-rodeo-tfr-2wd"
      }
    },
    {
      "Drover": {
        "(1985-1987)": "/collections/4wd-suspension-accessories-for-holden-drover"
      }
    },
    {
      "Jackaroo": {
        "LWB (1992-2004)": "/collections/4wd-suspension-accessories-for-holden-jackaroo-lwb-1992-2004",
        "SWB (1992-2004)": "/collections/4wd-suspension-accessories-for-holden-jackaroo-swb-1992-2004",
        "LWB (1983-1992)": "/collections/4wd-suspension-accessories-for-holden-jackaroo-lwb-1983-1992",
        "SWB (1983-1992)": "/collections/4wd-suspension-accessories-for-holden-jackaroo-swb-1983-1992"
      }
    }
  ],
  "Hyundai": [
    {
      "Terracan": {
        "(2001-2006)": "/collections/4wd-suspension-accessories-for-hyundai-terracan-2001-2006"
      }
    }
  ],
  "Ineos": [
    {
      "Grenadier": {
        "(2023 on)": "/collections/4wd-suspension-accessories-for-ineos-grenadier-2023-on"
      }
    }
  ],
  "Isuzu": [
    {
      "D-MAX": {
        "(2024 on)": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2024-on",
        "(2020-2023)": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2020-2023",
        "(2012-2020)": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2012-2020",
        "(2008-2012)": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2008-2012",
        "(2003-2008)": "/collections/4wd-suspension-accessories-for-isuzu-d-max-2003-2008"
      }
    },
    {
      "MU-X": {
        "(2021 on)": "/collections/4wd-suspension-accessories-for-isuzu-mu-x-2021",
        "(2013-2020)": "/collections/4wd-suspension-accessories-for-isuzu-mu-x-2013-2020"
      }
    }
  ],
  "Jeep": [
    {
      "Grand Cherokee": {
        "WK2 (2010-2022)": "/collections/4wd-suspension-accessories-for-jeep-grand-cherokee-wk2",
        "WH/WK1 (NOT WK2) (2005-2010)": "/collections/4wd-suspension-accessories-for-jeep-grand-cherokee-wh-wk1-not-wk2",
        "WJ & WG (2.7L TD) (1999-2004)": "/collections/4wd-suspension-accessories-for-jeep-grand-cherokee-wj-wg-2-7l-td",
        "WJ & WG (4.7L V8 & 4.0L) (1999-2004)": "/collections/4wd-suspension-accessories-for-jeep-grand-cherokee-wj-wg-4-7l-v8-4-0l",
        "ZJ & ZG (3.1L & 4.OL) (1993-1998)": "/collections/4wd-suspension-accessories-for-jeep-grand-cherokee-zj-zg-3-1l-4-ol"
      }
    },
    {
      "Cherokee": {
        "KK 3.7L V6 (2008-2012)": "/collections/4wd-suspension-accessories-for-jeep-cherokee-kk-3-7l-v6",
        "KJ Diesel (2002-2007)": "/collections/4wd-suspension-accessories-for-jeep-cherokee-kj-diesel",
        "KJ Petrol (2002-2007)": "/collections/4wd-suspension-accessories-for-jeep-cherokee-kj-petrol",
        "XJ (Excl Grand) (1984-2001)": "/collections/4wd-suspension-accessories-for-jeep-cherokee-xj-excl-grand"
      }
    },
    {
      "Wrangler": {
        "JL/JT Gladiator (2019 on)": "/collections/4wd-suspension-accessories-for-jeep-wrangler-jl-jt-gladiator",
        "JK LWB Diesel (4 Door) (2007-2018)": "/collections/4wd-suspension-accessories-for-jeep-wrangler-jk-lwb-diesel-4-door",
        "JK SWB Diesel (2 Door) (2007-2018)": "/collections/4wd-suspension-accessories-for-jeep-wrangler-jk-swb-diesel-2-door",
        "JK LWB Petrol (4 Door) (2007-2018)": "/collections/4wd-suspension-accessories-for-jeep-wrangler-jk-lwb-petrol-4-door",
        "JK SWB Petrol (2 Door) (2007-2018)": "/collections/4wd-suspension-accessories-for-jeep-wrangler-jk-swb-petrol-2-door",
        "TJ 2.5/4L (1997-2006)": "/collections/4wd-suspension-accessories-for-jeep-wrangler-tj-2-5-4l"
      }
    },
    {
      "Commander": {
        "XH (2006-2010)": "/collections/4wd-suspension-accessories-for-jeep-commander-xh"
      }
    }
  ],
  "Kia": [
    {
      "Tasman": {
        "(2025 on)": "/collections/4wd-suspension-accessories-for-Kia-tasman-2025-on"
      }
    }
  ],
  "Land Rover": [
    {
      "Defender": {
        "(2020-2024)": "/collections/land-rover-defender-2020-2024",
        "110 - 2.5 TD & V8 Wagon (1983-1990)": "/collections/4wd-suspension-accessories-for-landrover-defender-110-2-5-td-v8-wagon",
        "110 - Cab Chassis (1983-2016)": "/collections/4wd-suspension-accessories-for-landrover-defender-110-cab-chassis",
        "110 - Isuzu Motor Wagon (1987-1900)": "/collections/4wd-suspension-accessories-for-landrover-defender-110-isuzu-motor-wagon",
        "130 - Cab Chassis (1990-2016)": "/collections/4wd-suspension-accessories-for-landrover-defender-130-cab-chassis"
      }
    },
    {
      "County": {
        "110 Diesel Wagon (1983-1990)": "/collections/4wd-suspension-accessories-for-landrover-county-110-diesel-wagon",
        "110 Diesel Cab Chassis (1983-1990)": "/collections/4wd-suspension-accessories-for-landrover-county-110-diesel-cab-chassis",
        "110 Petrol Cab Chassis (1983-1990)": "/collections/4wd-suspension-accessories-for-landrover-county-110-petrol-cab-chassis",
        "110 Petrol Wagon (1983-1990)": "/collections/4wd-suspension-accessories-for-landrover-county-110-petrol-wagon"
      }
    },
    {
      "Discovery": {
        "Series 1 & 2 (1989-2004)": "/collections/4wd-suspension-accessories-for-landrover-discovery-series-1-2",
        "Series 2 - TD5 (1999-2004)": "/collections/4wd-suspension-accessories-for-landrover-discovery-series-2-td5"
      }
    },
    {
      "Range Rover": {
        "(1971-1998)": "/collections/4wd-suspension-accessories-for-landrover-range-rover-1971-1998"
      }
    }
  ],
  "LDV": [
    {
      "T60": {
        "(2017 on)": "/collections/4wd-suspension-accessories-for-ldv-t60"
      }
    }
  ],
  "Mahindra": [
    {
      "PIK UP Tray Back": {
        "(2007 on)": "/collections/4wd-suspension-accessories-for-mahindra-pik-up-tray-back"
      }
    }
  ],
  "Mazda": [
    {
      "BT-50": {
        "(2024 on)": "/collections/4wd-suspension-accessories-for-mazda-bt-50-2024-on",
        "(2020-2023)": "/collections/4wd-suspension-accessories-for-mazda-bt-50-2020-2023",
        "(2011-2020)": "/collections/4wd-suspension-accessories-for-mazda-bt-50-2011-2020",
        "(2006-2011)": "/collections/4wd-suspension-accessories-for-mazda-bt-50-2006-2011",
        "2WD Hi-Rider (2011 on)": "/collections/4wd-suspension-accessories-for-mazda-bt-50-2wd-hi-rider-2011-on",
        "2WD Hi-Rider (2006-2011)": "/collections/4wd-suspension-accessories-for-mazda-bt-50-2wd-hi-rider-2006-2011",
        "2WD Low Rider (2006-2011)": "/collections/4wd-suspension-accessories-for-mazda-bt-50-2wd-low-rider-2006-2011"
      }
    },
    {
      "Bravo": {
        "Bravo B2500/2600 (1999-2006)": "/collections/4wd-suspension-accessories-for-mazda-bravo-b2500-2600-1999-2006",
        "Bravo B2500/2600 2WD (1999-2006)": "/collections/4wd-suspension-accessories-for-mazda-bravo-b2500-2600-2wd-1999-2006",
        "Bravo B2500/2600 (1987-1999)": "/collections/4wd-suspension-accessories-for-mazda-bravo-b2500-2600-1987-1999",
        "Bravo B2500/2600 2WD (1987-1999)": "/collections/4wd-suspension-accessories-for-mazda-bravo-b2500-2600-2wd-1987-1999"
      }
    }
  ],
  "Mitsubishi": [
    {
      "Triton": {
        "MV (2024 on)": "/collections/4wd-suspension-accessories-for-mitsubishi-triton-mv",
        "MR (2018-2023)": "/collections/mitsubishi-triton-mr",
        "MQ (04/2015-2018)": "/collections/mitsubishi-triton-mq-04-2015-2018",
        "MN (2009-2015)": "/collections/mitsubishi-triton-mn-2009-2015",
        "ML (2006-2009)": "/collections/mitsubishi-triton-ml-2006-2009",
        "MK (1996-2006)": "/collections/mitsubishi-triton-mk-1996-2006",
        "MK (2WD) (1996-2006)": "/collections/mitsubishi-triton-mk-2wd-1996-2006",
        "MJ (06/1992-1997)": "/collections/mitsubishi-triton-mj-06-1992-1997",
        "MJ (2WD) (06/1992-1997)": "/collections/mitsubishi-triton-mj-2wd-06-1992-1997",
        "ME-MH (1986-1996)": "/collections/mitsubishi-triton-me-mh-1986-1996",
        "ME-MH (2WD) (1986-1996)": "/collections/mitsubishi-triton-me-mh-2wd-1986-1996"
      }
    },
    {
      "Pajero": {
        "LWB NW-NX Petrol V6 (2011–2021)": "/collections/mitsubishi-pajero-lwb-nw-nx-petrol-v6-2011-2021",
        "LWB NW-NX 3.2 T/Diesel (2011–2021)": "/collections/mitsubishi-pajero-lwb-nw-nx-3-2-t-diesel-2011-2021",
        "SWB NM-NS - 3.2 T/Diesel (2000–2009)": "/collections/mitsubishi-pajero-swb-nm-ns-3-2-t-diesel-2000-2009",
        "SWB NM-NS - 3.5L Petrol V6 (2000–2006)": "/collections/mitsubishi-pajero-swb-nm-ns-3-5l-petrol-v6-2000-2006",
        "LWB NA-NG 4 CYL & V6 - Leaf Spring Rear Suspension (1983–1991)": "/collections/mitsubishi-pajero-lwb-na-ng-4-cyl-v6-leaf-spring-rear-suspension-1983-1991",
        "LWB NF-NG L146G V6 - Coil Spring Rear Suspension (1987–1991)": "/collections/mitsubishi-pajero-lwb-nf-ng-l146g-v6-coil-spring-rear-suspension-1987-1991",
        "LWB NH-NJ 6 CYL - Leaf Spring Rear Suspension (1991–1993)": "/collections/mitsubishi-pajero-lwb-nh-nj-6-cyl-leaf-spring-rear-suspension-1991-1993",
        "LWB NH-NL 6 CYL - Coil Spring Rear Suspension (1991–2000)": "/collections/mitsubishi-pajero-lwb-nh-nl-6-cyl-coil-spring-rear-suspension-1991-2000",
        "LWB NH-NL Diesel & T/D - Coil Spring Rear Suspension (1991–2000)": "/collections/mitsubishi-pajero-lwb-nh-nl-diesel-t-d-coil-spring-rear-suspension-1991-2000",
        "LWB NM-NT - 3.2 T/Diesel (2000–2006)": "/collections/mitsubishi-pajero-lwb-nm-nt-3-2-t-diesel-2000-2006",
        "LWB NM-NT - 3.5L Petrol V6 (2000–2006)": "/collections/mitsubishi-pajero-lwb-nm-nt-3-5l-petrol-v6-2000-2006",
        "SWB NA-NG 4 CYL & V6 - Leaf Spring Rear Suspension (1983–1991)": "/collections/mitsubishi-pajero-swb-na-ng-4-cyl-v6-leaf-spring-rear-suspension-1983-1991",
        "SWB NF-NG V6 - Coil Spring Rear Suspension (1987–1991)": "/collections/mitsubishi-pajero-swb-nf-ng-v6-coil-spring-rear-suspension-1987-1991",
        "SWB NH-NJ 6 CYL - Leaf Spring Rear Suspension (1991–1993)": "/collections/mitsubishi-pajero-swb-nh-nj-6-cyl-leaf-spring-rear-suspension-1991-1993",
        "SWB NH-NL 6 CYL - Coil Spring Rear Suspension (1991–2000)": "/collections/mitsubishi-pajero-swb-nh-nl-6-cyl-coil-spring-rear-suspension-1991-2000"
      }
    },
    {
      "Pajero Sport": {
        "QF (2020 on)": "/collections/mitsubishi-pajero-sport-qf-2020-on",
        "QE (2016-2020)": "/collections/mitsubishi-pajero-sport-qe-2016-2020"
      }
    },
    {
      "Challenger": {
        "(2000 on)": "/collections/mitsubishi-challenger-2000",
        "(1998-2000)": "/collections/mitsubishi-challenger-1998-2000",
        "PB-KH Wagon (2009–2015)": "/collections/mitsubishi-challenger-pb-kh-wagon-2009-2015"
      }
    }
  ],
  "Nissan": [
    {
      "720": "/collections/nissan-720"
    },
    {
      "Navara": {
        "NP300 (2021 on)": "/collections/4wd-suspension-accessories-for-nissan-navara-np300-2021-on",
        "NP300 Coil/Coil": "/collections/nissan-navara-np300-coil-rear",
        "NP300 Coil/Leaf": "/collections/nissan-navara-np300-leaf-rear",
        "NP300 (2015-2020)": "/collections/nissan-navara-np300-2015-2020",
        "D40 (11/2005-05/2015)": "/collections/nissan-navara-d40-11-2005-05-2015",
        "D40 STX (11/2005-05/2015)": "/collections/nissan-navara-d40-stx-11-2005-05-2015",
        "D22 (03/1997-11/2007)": "/collections/nissan-navara-d22-03-1997-11-2007",
        "D21 (02/1986-02/1997)": "/collections/nissan-navara-d21-02-1986-02-1997"
      }
    },
    {
      "Pathfinder": {
        "R51 (2005-2012)": "/collections/nissan-pathfinder-r51-2005-2012",
        "R50 (1995-2004)": "/collections/nissan-pathfinder-r50-1995-2004",
        "WD21 (1986-1995)": "/collections/nissan-pathfinder-wd21-1986-1995"
      }
    },
    {
      "Patrol": {
        "Y62 (2010 on)": "/collections/nissan-patrol-y62-2010-on",
        "GU LWB Wagon (1997–2016)": "/collections/nissan-patrol-gu-lwb-wagon-1997-2016",
        "GU Ute Coil/Leaf (1997–2016)": "/collections/nissan-patrol-gu-ute-coil-leaf-1997-2016",
        "GU Ute Coil/Coil (1997–2016)": "/collections/nissan-patrol-gu-ute-coil-coil-1997-2016",
        "GQ LWB Wagon (1988–1997)": "/collections/nissan-patrol-gq-lwb-wagon-1988-1997",
        "GQ SWB Wagon (1988–1997)": "/collections/nissan-patrol-gq-swb-wagon-1988-1997",
        "GQ Ute Coil/Coil (1988–1997)": "/collections/nissan-patrol-gq-ute-coil-coil-1988-1997",
        "GQ Ute Coil/Leaf (1988–1997)": "/collections/nissan-patrol-gq-ute-coil-leaf-1988-1997",
        "MK LWB Square Lights (1983–1988)": "/collections/nissan-patrol-mk-lwb-square-lights-1983-1988",
        "MK SWB Square Lights (1983–1988)": "/collections/nissan-patrol-mk-swb-square-lights-1983-1988",
        "MQ LWB Round Lights (1980–1983)": "/collections/nissan-patrol-mq-lwb-round-lights-1980-1983",
        "MQ SWB Round Lights (1980–1983)": "/collections/nissan-patrol-mq-swb-round-lights-1980-1983"
      }
    },
    {
      "X-TRAIL": {
        "T30 Series 1/2 (2001–2007)": "/collections/nissan-x-trail-t30-series-1-2-2001-2007"
      }
    }
  ],
  "RAM": [
    {
      "1500 DT": {
        "(2019 on)": "/collections/dodge-ram-1500-dt"
      }
    },
    {
      "1500 DS Classic": {
        "(2013-2021)": "/collections/dodge-ram-1500-ds-classic"
      }
    },
    {
      "2500 DT": {
        "(2019 on)": "/collections/dodge-ram-2500-dt"
      }
    },
    {
      "2500 DS": {
        "(2013-2018)": "/collections/dodge-ram-2500-ds"
      }
    },
    {
      "3500 DJ2 (2019 on)": {
        "(2019 on)": "/collections/dodge-ram-3500"
      }
    }
  ],
  "SsangYong": [
    {
      "Musso": {
        "290S Sport (2003-2006)": "/collections/ssangyong-musso-290s-sport-2003-2006"
      }
    }
  ],
  "Suzuki": [
    {
      "Grand Vitara": {
        "Grand Vitara (1998-2001)": "/collections/suzuki-grand-vitara-grand-vitara-1998-2001",
        "Grand Vitara V6 (1998-2001)": "/collections/suzuki-grand-vitara-grand-vitara-v6-1998-2001",
        "Grand Vitara XL7 (2001-2005)": "/collections/suzuki-grand-vitara-grand-vitara-xl7-2001-2005",
        "Grand Vitara JB 4Cyl Petrol (2005-2015)": "/collections/suzuki-grand-vitara-grand-vitara-jb-4cyl-petrol-2005-2015",
        "Grand Vitara JB V6 Petrol/Diesel (2005-2015)": "/collections/suzuki-grand-vitara-grand-vitara-jb-v6-petrol-diesel-2005-2015"
      }
    },
    {
      "Jimny": {
        "(2023 on)": "/collections/4wd-suspension-accessories-for-suzuki-jimny-5-door-2023-on",
        "SWB (EXL NEW MODEL) (1998–2018)": "/collections/suzuki-jimny-swb-exl-new-model-1998-2018"
      }
    },
    {
      "Sierra": {
        "SJ & LJ 410/413 - (EXCL TRAY BACK) (1974-12/1998)": "/collections/suzuki-sierra-sj-lj-410-413-excl-tray-back-1974-12-1998"
      }
    },
    {
      "Vitara": {
        "1.6 L SWB (07/1988-05/1998)": "/collections/suzuki-vitara-1-6-l-swb-07-1988-05-1998",
        "4 Door (EXCL V6) (1991-1998)": "/collections/suzuki-vitara-4-door-excl-v6-1991-1998",
        "4 Door V6 only (1995-1998)": "/collections/suzuki-vitara-4-door-v6-only-1995-1998",
        "2.0L SWB (07/1988-05/1998)": "/collections/suzuki-vitara-2-0l-swb-07-1988-05-1998"
      }
    }
  ],
  "Toyota": [
    {
      "LandCruiser": {
        "300 Series": "/collections/toyota-landcruiser-300-series",
        "200 Series": "/collections/toyota-landcruiser-200-series",
        "105 Series": "/collections/toyota-landcruiser-105-series",
        "100 Series (Diesel)": "/collections/toyota-landcruiser-100-series-diesel",
        "100 Series (Petrol)": "/collections/toyota-landcruiser-100-series-petrol",
        "80 Series": "/collections/toyota-landcruiser-80-series",
        "70 Series": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-70-series",
        "79 Series Dual Cab (post-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-dual-cab-post-dpf",
        "79 Series Single Cab (post-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-single-cab-post-dpf",
        "79 Series Single Cab (pre-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-single-cab-pre-dpf",
        "79 Series Dual Cab (pre-DPF)": "/collections/4wd-suspension-accessories-for-Toyota-Landcruiser-79-series-dual-cab-pre-dpf",
        "79 Series (2023 on)": "/collections/4wd-suspension-accessories-for-toyota-landcruiser-79-2023-on",
        "78 Series (1999-2006)": "/collections/toyota-landcruiser-78-series-1999-2006",
        "78 Series (2006 on)": "/collections/toyota-landcruiser-78-series-2006-on",
        "76 Series": "/collections/toyota-landcruiser-76-series",
        "75 Series (Cab Chassis)": "/collections/toyota-landcruiser-75-series-cab-chassis",
        "75 Series (Troop Carrier)": "/collections/toyota-landcruiser-75-series-troop-carrier",
        "60 Series (Post 10/1985)": "/collections/toyota-landcruiser-60-series-post-10-1985",
        "60 Series (Pre 10/1985)": "/collections/toyota-landcruiser-60-series-pre-10-1985",
        "47 Series (Ute) (08/1980-04/1986)": "/collections/toyota-landcruiser-47-series-ute-08-1980-04-1986",
        "47 Series (Troop Carrier) (08/1980-04/1986)": "/collections/toyota-landcruiser-47-series-troop-carrier-08-1980-04-1986",
        "45 Series (Ute) (08/1980-04/1986)": "/collections/toyota-landcruiser-45-series-ute-08-1980-04-1986",
        "45 Series (Ute) (03/1969-07/1980)": "/collections/toyota-landcruiser-45-series-ute-03-1969-07-1980",
        "45 Series (Troop Carrier) (08/1980-04/1986)": "/collections/toyota-landcruiser-45-series-troop-carrier-08-1980-04-1986",
        "45 Series (Troop Carrier) (03/1969-07/1980)": "/collections/toyota-landcruiser-45-series-troop-carrier-03-1969-07-1980",
        "40 Series (Large Eye) (08/1980-04/1986)": "/collections/toyota-landcruiser-40-series-large-eye-08-1980-04-1986",
        "40 Series (Small Eye) (1969 to 07/1980) (Shorty 40)": "/collections/toyota-landcruiser-40-series-small-eye-1969-to-07-1980-shorty-40"
      }
    },
    {
      "HiLux": {
        "GUN N80 (2015 on)": "/collections/4wd-suspension-accessories-for-toyota-hilux-gun-n80-2015-on",
        "Rogue Wide Body (2018 on)": "/collections/4wd-suspension-accessories-for-toyota-hilux-rogue-wide-body-2018-on",
        "KUN N70 (2005-2015)": "/collections/4wd-suspension-accessories-for-toyota-hilux-kun-n70-2005-2015",
        "2WD (2005 on)": "/collections/4wd-suspension-accessories-for-toyota-hilux-2wd-2005-on",
        "2WD (to 2005)": "/collections/4wd-suspension-accessories-for-toyota-hilux-2wd-to-2005",
        "Leaf/Leaf (Diesel) (03/1984-1997)": "/collections/4wd-suspension-accessories-for-toyota-hilux-leaf-leaf-diesel-03-1984-1997",
        "Leaf/Leaf (Petrol) (03/1984-1997)": "/collections/4wd-suspension-accessories-for-toyota-hilux-leaf-leaf-petrol-03-1984-1997",
        "Leaf/Leaf (Diesel) (1979-02/1984)": "/collections/4wd-suspension-accessories-for-toyota-hilux-leaf-leaf-diesel-1979-02-1984",
        "Leaf/Leaf (Petrol) (1979-02/1984)": "/collections/4wd-suspension-accessories-for-toyota-hilux-leaf-leaf-petrol-1979-02-1984",
        "Torsion Bar Front - Leaf Spring Rear - KZN165, LN107, LN167, LN172, LN176, RZN169R (1997-03/2005)": "/collections/4wd-suspension-accessories-for-Toyota-HiLux-torsion-bar-front-1997-03-2005",
        "Torsion Bar Front - Leaf Spring Rear - RN110, LN111 (08/1988-1996)": "/collections/4wd-suspension-accessories-for-Toyota-HiLux-torsion-bar-front-08-1988-1996",
        "Torsion Bar Front - Leaf Spring Rear - LN61, YN63 (08/1985 - 1988)": "/collections/4wd-suspension-accessories-for-Toyota-HiLux-torsion-bar-front-08-1985-1988"
      }
    },
    {
      "Prado": {
        "250 Series (2024 on)": "/collections/4wd-suspension-accessories-for-Toyota-Prado-250-Series-2024-on",
        "150 Series (2009-2023)": "/collections/toyota-prado-150-series-2009-2023",
        "120/121/125 Series (2003-2009)": "/collections/toyota-prado-120-121-125-series-2003-2009",
        "95 Series (LWB) (1996-2002)": "/collections/toyota-prado-95-series-lwb-1996-2002",
        "90 Series (1996-2002)": "/collections/toyota-prado-90-series-1996-2002"
      }
    },
    {
      "FJ Cruiser": {
        "(2011-2017)": "/collections/toyota-fj-cruiser-2011-2017"
      }
    },
    {
      "Fortuner": {
        "Fortuner Diesel (2015-2020)": "/collections/toyota-fortuner-fortuner-diesel-2015-2020",
        "Fortuner Petrol (2005-2015)": "/collections/toyota-fortuner-fortuner-petrol-2005-2015",
        "N160 (2021 on)": "/collections/toyota-fortuner-n160-2021-on"
      }
    },
    {
      "4Runner": {
        "LN61 & LN63 (IFS/leaf spring rear) (1985-1989)": "/collections/toyota-4runner-ln61-ln63-ifs-leaf-spring-rear-1985-1989",
        "Diesel - All Leaf Spring Axle Models (08/1985 on)": "/collections/toyota-4runner-diesel-all-leaf-spring-axle-models-08-1985-on",
        "Petrol - All Leaf Spring Front Axle Models (08/1985 on)": "/collections/toyota-4runner-petrol-all-leaf-spring-front-axle-models-08-1985-on",
        "IFS - Coil Spring Rear - 130 Chassis (1989-1996)": "/collections/toyota-4runner-ifs-coil-spring-rear-130-chassis-1989-1996"
      }
    },
    {
      "Surf": {
        "IFS 130 Chassis (1989-1996)": "/collections/toyota-surf-ifs-130-chassis-1989-1996",
        "Coil/Coil 185 Chassis (1996–2002)": "/collections/toyota-surf-coil-coil-185-chassis-1996-2002"
      }
    },
    {
      "Tundra": {
        "K7 TDR Pro (2022 on)": "/collections/4wd-suspension-accessories-for-toyota-tundra-k7-tdr-pro",
        "K7 Limited (2022 on)": "/collections/4wd-suspension-accessories-for-toyota-tundra-k7-limited"
      }
    }
  ],
  "Volkswagen": [
    {
      "Amarok": {
        "NF (2023 on)": "/collections/4wd-suspension-accessories-for-Volkswagen-Amarok-2023-on",
        "Petrol (2010-2022)": "/collections/volkswagen-amarok-petrol-2010-2022",
        "V6 Diesel (2010-2022)": "/collections/volkswagen-amarok-v6-diesel-2010-2022"
      }
    }
  ],
  "Mercedes": [
    {
      "X-Class": {
        "(2017-2020)": "/collections/mercedes-x-class-2017-2020"
      }
    }
  ]
}